<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Budjet ma'lumot turi turi" prop="info_type">
                <el-select style="width: 100%" size="large" v-model="form.info_type">
                  <el-option v-for="{type, title} in infoTypes" :key="type" :value="type" :label="title"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Budjet yili" prop="budget_year">
                <el-input-number controls-position="right" size="large" class="form-input" v-model="form.budget_year" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="()=>this.$router.go(-1)">Orqaga</el-button>
                <el-button class="custom-btn" type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "StateBudgetForm",
  data() {
    return {
      loading: false,
      infoTypes: [{type: 'INCOME', title: 'Daromadlar'}, {type: 'OUTCOME', title: 'Xarajatlar'}],
      form: {
        budget_year: null,
        info_type: "INCOME"
      },
      rules: {
        budget_year: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        info_type: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;

          let http;

          const formData = {...this.form}


          http = this.$http.post('/api/v1/state-budget', formData);


          http.then(() => {
            ElNotification({
              title: 'Tabriklaymiz',
              message: 'Muvafaqiyatli saqlandi',
              type: 'success',
            })
            this.$router.go(-1)
          }).catch(({response}) => {
            ElNotification({
              title: 'Xatolik',
              message: response.data.message || "Iltimos, qayta urinib ko'ring.",
              type: 'error',
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
